<template>
    <main>
        <section class="hero tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
            <div class="info-container">

            </div>
            <div class="form-container">
                <img src="~@/assets/img/logo.svg" alt="Clarins">
                <Form v-if="!$store.state.formSuccess" />
                <FormSuccess v-if="$store.state.formSuccess" />
            </div>
        </section>
        <section class="offers tw-py-10 lg:tw-py-16">
            <div class="tw-container">
                <h2>Uw voordelen</h2>
                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-5 tw-gap-5 lg:tw-gap-4">
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/1.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">-20% op uw eerste<br> bestelling*</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/2.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Gratis retourzending <br>voor orders vanaf €70**</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/3.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Kies 3 gratis <br>samples**</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/4.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Exclusieve <br>geschenken**</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/5.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Uw aankopen<br> beloond**</p>
                    </div>
                </div>
            </div>
        </section>
        <footer>
            <div class="tw-container">
                <div>
                    <p class="tw-text-left tw-text-black tw-mb-2">* Directe korting: profiteer als lid van 20% korting op ons online aanbod, vanaf de eerste aankoop.</p>
                    <p class="tw-text-left tw-text-black tw-mb-2">**Bekijk de voorwaarden op bnl.clarins.com <a href="https://bnl.clarins.com/on/demandware.store/Sites-clarinsbnl-Site/nl/" target="_blank">bnl.clarins.com</a></p>
                    <p class="tw-text-left tw-text-black tw-mb-2">Informatie vanuit dit formulier wordt in overeenstemming met ons privacybeleid gebruikt voor digitale verwerking van Clarins haar serviceproviders om je gerichte informatie over onze producten en diensten te kunnen sturen. De prospect-/klantgegevens worden bewaard, behoudens bezwaar of verzoek om verwijdering door jezelf, gedurende een periode van drie jaar vanaf jouw laatste aankoop of laatste contact. Je beschikt over het recht tot inzage, rechtzetting, schrapping en overdraagbaarheid van jouw persoonsgegevens en een recht op bezwaar en beperking van de verwerking door contact met ons op te nemen. Voor meer informatie hierover, gelieve ons privacybeleid te consulteren op onze website.</p>
                    <p class="tw-text-left tw-text-black">© Clarins. All Rights Reserved</p>
                </div>
            </div>
        </footer>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';

main {

    section {

        &.hero {

            .info-container {
                @apply tw-bg-no-repeat tw-bg-cover tw-bg-center;
                background-image: url('~@/assets/img/hero-new-desktop.jpg');

                @screen lg {
                    @apply tw-block;
                    height: 768px;
                }
            }

            .form-container {
                @apply tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-12;

                >img {
                    @apply tw-pointer-events-none;
                    margin-bottom: 32px;

                    @screen lg {
                        width: 221.62px;
                        margin-bottom: 40px;
                    }
                }

                @screen lg {
                    @apply tw-h-full tw-pt-0;
                }
            }
        }

        &.offers {
            background-color: $light-bg;

            .tw-container {

                h2 {
                    @apply tw-text-center;
                    color: $main_color;
                    font-family: 'Clarins';
                    font-size: 26px;
                    line-height: 32px;
                    padding-bottom: 60px;

                    @screen lg {
                        font-size: 26px;
                        padding-bottom: 76px;
                    }
                }

                .tw-grid {

                    >div {

                        img {
                            @apply tw-pointer-events-none;
                        }

                        p {
                            font-family: 'Clarins';

                            @screen lg {
                                font-size: 20px;
                                line-height: 26px;
                            }
                        }
                    }
                }
            }
        }
    }

    footer {
        padding: 40px 0;

        @screen lg {
            padding: 48px 0;
        }

        line-height: 14px;
        font-size: 10px;
    }
}
</style>
